
import {Component, Vue, Prop} from "vue-property-decorator";
import GuestInvitationOptions from "@/components/keys/GuestInvitationOptions.vue";
import {Getter} from "vuex-class";

@Component({
    components: {
        GuestInvitationOptions,
    },
})
export default class EditKeyAccess extends Vue {

    @Prop({default: null})
    public keyAccess: any;

    private editDialog: boolean = true;
    private loadingEdit: boolean = false;
    private invitation: any = {};

    @Getter private canDoInEnvCompany: (right: string) => boolean;

    private mounted(): void {
      this.invitation = {
        ...this.keyAccess,
        timeLimited: !!this.keyAccess.endDate,
        countLimited: this.keyAccess.countAccessLeft !== -1,
      };
    }

    private async editGuestAccess(): Promise<void> {
      this.loadingEdit = true;
      await this.$store.dispatch("keyAccesses/updateById", {
        id: this.keyAccess.id,
        data: {
          countAccessLeft: this.invitation.countAccessLeft,
          startDate: this.invitation.startDate,
          endDate: this.invitation.endDate || null,
        },
      }).then(() => {
        this.$emit("reset");
      }).catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      }).finally(() => {
        this.loadingEdit = false;
      });
    }
}
